<nav class="nav nav-secondary" [class.widget]="isWidget">
  <ng-container *ngIf="tabs?.length > 0">
    <div
      class="nav-item cursor-pointer"
      *ngFor="let tab of tabs; let i = index"
      [class.active]="selectedIndex === i"
      [ngStyle]="tabStyle"
      (click)="selectTab(i, $event)"
    >
      <label>{{ tab }}</label>
    </div>
  </ng-container>
</nav>
